import React, { useEffect, useState } from "react";

import { getWidgetPhotos } from "../../data/httpClient";
import { WidgetPhoto } from "../../types";
import ImagePreviewModal from "./ImagePreviewModal";

type WidgetPhotoProps = {
  widgetId: number;
  widgetTypeId: number;
};

const WidgetPhotoDisplay: React.FC<WidgetPhotoProps> = ({ widgetId }) => {
  const [allPhotos, setAllPhotos] = useState<WidgetPhoto[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
    getWidgetPhotos(widgetId).then(setAllPhotos);
  }, [widgetId]);

  const photosPerPage = 15;
  const totalPages = Math.ceil(allPhotos.length / photosPerPage);
  const pagedPhotos = allPhotos.slice(
    (page - 1) * photosPerPage,
    page * photosPerPage
  );

  // NOTE ABOUT URL.
  // The rails app used to take full sized images and downsize smartly.
  // we have both the full size .jpg and a smaller .png in cloud storage.
  // The database thinks we have .jpgs and we do, but we load the png to save speed
  // Finishing the widget upload/edit feature should validate max image size. & this can go.
  return (
    <>
      <div className="widget-photo-container">
        {pagedPhotos.map((photo, index) => (
          <div
            role="button"
            key={photo.id}
            className="mosaic-photo"
            tabIndex={0}
            aria-label={`Open tournament photo preview (${(page - 1) * photosPerPage + index + 1} of ${allPhotos.length})`}
            onClick={() => {
              setIsOpen(true);
              setSelectedImage(photo.photoUrl);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setIsOpen(true);
                setSelectedImage(photo.photoUrl);
              }
            }}
          >
            <img
              src={photo.photoUrl}
              alt=""
              id={`tournament-photo-${photo.id}`}
            />
          </div>
        ))}
      </div>
      {totalPages > 1 && (
        <div className="pagination-wrapper">
          <button
            type="button"
            onClick={() => setPage(page - 1)}
            className={page === 1 ? "primaryBtnDisabled" : "paginationBtns"}
            disabled={page === 1}
          >
            Prev
          </button>
          <span className="page-count">
            Page {page} of {totalPages}
          </span>
          <button
            type="button"
            className={
              page === totalPages ? "primaryBtnDisabled" : "paginationBtns"
            }
            onClick={() => setPage(page + 1)}
            disabled={page === totalPages}
          >
            Next
          </button>
        </div>
      )}
      <ImagePreviewModal
        imgSrc={selectedImage || ""}
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default WidgetPhotoDisplay;
